import { useState } from "react";
import { api, formatApiError, formatZAR } from "@/lib/api";

export default function TrackOrder() {
  const [orderNumber, setOrderNumber] = useState("");
  const [order, setOrder] = useState(null);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setOrder(null); setLoading(true);
    try {
      const { data } = await api.get(`/orders/track/${orderNumber.trim()}`);
      setOrder(data);
    } catch (e) {
      setErr(formatApiError(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="track-order-page" className="max-w-2xl mx-auto px-6 py-20">
      <p className="small-label">Track your order</p>
      <h1 className="font-serif text-4xl sm:text-5xl mt-3">Where is my wig?</h1>
      <p className="text-stone mt-3">Enter your order number to view its journey.</p>

      <form onSubmit={submit} className="mt-8 flex gap-3">
        <input
          required
          value={orderNumber}
          onChange={(e) => setOrderNumber(e.target.value)}
          placeholder="ML-XXXXXXXX"
          data-testid="track-order-input"
          className="flex-1 bg-ivory border border-stone-line rounded-full px-5 py-3.5 text-sm uppercase tracking-luxe focus:outline-none focus:ring-1 focus:ring-charcoal"
        />
        <button data-testid="track-order-submit" disabled={loading} className="btn-primary">{loading ? "…" : "Track"}</button>
      </form>

      {err && <p className="mt-6 text-sm text-red-700" data-testid="track-error">{err}</p>}

      {order && (
        <div className="mt-10 bg-nude rounded-3xl p-8">
          <p className="small-label">Order {order.order_number}</p>
          <p className="font-serif text-2xl mt-2 capitalize">{order.fulfillment_status}</p>
          <p className="small-label mt-4">Placed</p>
          <p className="text-sm">{new Date(order.created_at).toLocaleString("en-ZA")}</p>
          <p className="small-label mt-4">Total</p>
          <p className="text-sm">{formatZAR(order.total)}</p>
          <p className="small-label mt-4">Shipping to</p>
          <p className="text-sm">{order.customer.first_name} {order.customer.last_name} · {order.customer.city}, {order.customer.province}</p>
        </div>
      )}
    </div>
  );
}
